import { LoanFormatState } from '../../app-store/loanFormat/loanFormatReducer';

export enum LoanFormatKeys {
    LOANFORMAT_EAUDIOBOOKS = 'LOANFORMAT_EAUDIOBOOKS',
    LOANFORMAT_EBOOKS = 'LOANFORMAT_EBOOKS',
    LOANFORMAT_EPRESS = 'LOANFORMAT_EPRESS',
    LOANFORMAT_ALL = 'LOANFORMAT_ALL'
}

export const LOANFORMAT_EAUDIOBOOKS = 'EAUDIOBOOKS';
export const LOANFORMAT_EBOOKS = 'EBOOKS';
export const LOANFORMAT_EPRESS = 'EPRESS';
export const LOANFORMAT_ALL = 'ALL';
export const URL_LOANFORMAT_EAUDIOBOOKS = 'eaudiobooks';
export const URL_LOANFORMAT_EBOOKS = 'ebooks';
export const URL_LOANFORMAT_EPRESS = 'epress';
export const URL_LOANFORMAT_EPRESS_ISSUES = 'emagazineissues';
export const URL_LOANFORMAT_ALL = 'all';
export const LOANFORMAT_ALL_OBJECT: LoanFormatState = {
    // the backend expects no loanFormat query param as the default which shows all objects
    // that might be the reason why there is this split between the key and requestKey
    requestKey: null,
    key: LOANFORMAT_ALL,
    name: 'All Formats',
    singularName: null,
    icon: 'star-outline',
    urlKey: URL_LOANFORMAT_ALL
};
export const LOANFORMAT_EBOOK_OBJECT: LoanFormatState = {
    requestKey: LOANFORMAT_EBOOKS,
    key: LOANFORMAT_EBOOKS,
    name: 'eBooks',
    singularName: 'eBook',
    icon: 'ebook-filled',
    urlKey: URL_LOANFORMAT_EBOOKS
};
export const LOANFORMAT_EAUDIOBOOK_OBJECT: LoanFormatState = {
    requestKey: LOANFORMAT_EAUDIOBOOKS,
    key: LOANFORMAT_EAUDIOBOOKS,
    name: 'eAudiobooks',
    singularName: 'eAudiobook',
    icon: 'eaudiobook-filled',
    urlKey: URL_LOANFORMAT_EAUDIOBOOKS
};
export const LOANFORMAT_EPRESS_OBJECT: LoanFormatState = {
    requestKey: LOANFORMAT_EPRESS,
    key: LOANFORMAT_EPRESS,
    name: 'ePress',
    singularName: 'ePress',
    icon: 'emagazine-filled',
    urlKey: URL_LOANFORMAT_EPRESS
};
/**
 * @deprectaed
 */
export const LOANFORMAT_EMAGAZINES_OBJECT: LoanFormatState = {
    requestKey: 'EMAGAZINES',
    key: 'EMAGAZINES',
    name: 'eMagazines',
    singularName: 'eMagazine',
    icon: 'emagazine-filled',
    urlKey: 'emagazines'
};
